/**
 * Configuración centralizada de estados de órdenes de trabajo
 * Contiene los estados disponibles con su traducción y color asociado
 */
export const ORDER_STATUS = {
    CREATED: {
        value: 'CREATED',
        label: 'Creada',
        color: '#6C757D',
    },
    APPROVED: {
        value: 'APPROVED',
        label: 'Aprobada',
        color: '#FF8C00',
    },
    MAINTENANCE: {
        value: 'MAINTENANCE',
        label: 'En Mantenimiento',
        color: '#28A745',
    },
    FINALIZED: {
        value: 'FINALIZED',
        label: 'Finalizada',
        color: '#024a97ff',
    },
    DISCARDED: {
        value: 'DISCARDED',
        label: 'Descartada',
        color: '#DC3545',
    },
};

/**
 * Obtiene la configuración de un estado específico
 * @param {string} status - Estado de la orden
 * @returns {Object} Configuración del estado con value, label y color
 */
export const getOrderStatusConfig = (status) => {
    return ORDER_STATUS[status] || { value: status, label: status, color: '#6c757d' };
};

/**
 * Obtiene array de estados disponibles para transiciones
 * @param {string} currentStatus - Estado actual de la orden
 * @returns {Array} Array de estados disponibles con value, label y color
 */
export const getAvailableStatusTransitions = (currentStatus) => {
    const transitions = {
        CREATED: ['APPROVED', 'DISCARDED'],
        APPROVED: ['MAINTENANCE', 'DISCARDED'],
        MAINTENANCE: ['FINALIZED', 'DISCARDED'],
        FINALIZED: [],
        DISCARDED: [],
    };

    const availableStatuses = transitions[currentStatus] || [];
    return availableStatuses.map((status) => ORDER_STATUS[status]);
};
